export const carouselData = [
  {
    id: 1,
    tag: "娱乐圈",
    title: "顶流艺人深夜发文回应争议，粉丝集体破防",
    summary: "继连续一周热搜霸榜后，该艺人于今日凌晨发布长文，首次正面回应近期围绕其私生活的种种传闻，声明态度坚决引发新一轮讨论。",
    image: "https://readdy.ai/api/search-image?query=A%20dramatic%20stage%20spotlight%20on%20a%20single%20microphone%20with%20warm%20orange%20and%20amber%20tones%2C%20artistic%20abstract%20composition%2C%20soft%20bokeh%20background%2C%20editorial%20entertainment%20photography%2C%20high%20contrast%2C%20mysterious%20atmosphere%2C%20cinematic%20lighting&width=800&height=500&seq=carousel-01&orientation=landscape",
    heat: "98.7万热度",
    time: "3小时前"
  },
  {
    id: 2,
    tag: "影视综",
    title: "热播剧大结局编剧被骂上热搜，制片人紧急回应",
    summary: "年度话题剧集迎来大结局，然而剧情走向令大量观众不满，社交媒体掀起讨论狂潮，编剧微博评论区一度沦陷。",
    image: "https://readdy.ai/api/search-image?query=A%20dramatic%20theater%20curtain%20partially%20opened%20with%20warm%20golden%20light%20spilling%20out%2C%20artistic%20abstract%20style%2C%20rich%20amber%20and%20coral%20tones%2C%20cinematic%20composition%2C%20soft%20texture%2C%20mysterious%20theater%20atmosphere&width=800&height=500&seq=carousel-02&orientation=landscape",
    heat: "156.2万热度",
    time: "5小时前"
  },
  {
    id: 3,
    tag: "综艺",
    title: "综艺录制现场意外片段曝光，节目组发布声明",
    summary: "一段未经剪辑的录制片段在网络上疯传，内容涉及嘉宾之间的矛盾冲突，引发网友对综艺真实性的新一轮讨论。",
    image: "https://readdy.ai/api/search-image?query=A%20bright%20TV%20studio%20set%20with%20colorful%20stage%20lights%20in%20warm%20orange%20and%20pink%20tones%2C%20abstract%20artistic%20representation%20of%20variety%20show%20atmosphere%2C%20soft%20glow%2C%20dynamic%20energy%2C%20editorial%20style&width=800&height=500&seq=carousel-03&orientation=landscape",
    heat: "87.4万热度",
    time: "8小时前"
  },
  {
    id: 4,
    tag: "音乐",
    title: "年度音乐节全阵容官宣，多组重量级艺人加盟",
    summary: "备受瞩目的年度音乐节正式公布完整演出阵容，涵盖流行、摇滚、电子等多个音乐类型，早鸟票开售即秒罄。",
    image: "https://readdy.ai/api/search-image?query=A%20vibrant%20music%20festival%20stage%20with%20colorful%20lights%20and%20crowd%20silhouettes%2C%20warm%20golden%20and%20coral%20atmosphere%2C%20abstract%20artistic%20style%2C%20dynamic%20energy%2C%20soft%20bokeh%20effect%2C%20festive%20celebration%20vibe&width=800&height=500&seq=carousel-04&orientation=landscape",
    heat: "72.1万热度",
    time: "12小时前"
  },
  {
    id: 5,
    tag: "电竞",
    title: "知名电竞选手宣布退役，八年职业生涯回顾",
    summary: "该选手在个人直播间正式宣布退役决定，回顾了八年来从新人到世界冠军的历程，粉丝纷纷刷屏致敬。",
    image: "https://readdy.ai/api/search-image?query=A%20futuristic%20esports%20arena%20with%20dramatic%20neon%20stage%20lighting%20in%20warm%20amber%20and%20orange%20tones%2C%20abstract%20gaming%20atmosphere%2C%20cinematic%20composition%2C%20high%20contrast%2C%20emotional%20farewell%20mood&width=800&height=500&seq=carousel-05&orientation=landscape",
    heat: "63.8万热度",
    time: "1天前"
  }
];

export const indexData = [
  { id: 1, title: "明星八卦", icon: "ri-star-smile-line", count: "2,341篇", desc: "最新娱乐圈动态与明星资讯" },
  { id: 2, title: "影视综艺", icon: "ri-movie-2-line", count: "1,856篇", desc: "热门剧集讨论与综艺看点" },
  { id: 3, title: "音乐现场", icon: "ri-music-2-line", count: "1,203篇", desc: "演唱会、音乐节与新歌发布" },
  { id: 4, title: "电竞游戏", icon: "ri-gamepad-line", count: "987篇", desc: "职业赛事与游戏圈热点" },
  { id: 5, title: "社会热点", icon: "ri-fire-line", count: "3,102篇", desc: "全网热议的社会话题讨论" },
  { id: 6, title: "搞笑段子", icon: "ri-emotion-laugh-line", count: "1,678篇", desc: "每日欢乐放松一刻" },
  { id: 7, title: "情感故事", icon: "ri-heart-2-line", count: "892篇", desc: "真实情感经历与感悟分享" },
  { id: 8, title: "科技数码", icon: "ri-smartphone-line", count: "756篇", desc: "科技新品与数码圈大事件" },
  { id: 9, title: "美食探店", icon: "ri-restaurant-line", count: "1,434篇", desc: "网红美食与城市打卡指南" }
];

export const commentsData = [
  {
    id: 1,
    avatar: "https://readdy.ai/api/search-image?query=A%20simple%20minimalist%20abstract%20avatar%20with%20warm%20coral%20background%2C%20soft%20geometric%20shape%2C%20clean%20design%2C%20modern%20style&width=80&height=80&seq=avatar-01&orientation=squarish",
    name: "吃瓜不嫌事大",
    time: "28分钟前",
    content: "这个瓜我吃了三天了，每天都有新进展，比连续剧还精彩！建议大家理性吃瓜，不要随意站队。",
    likes: 2.3,
    tag: "热评"
  },
  {
    id: 2,
    avatar: "https://readdy.ai/api/search-image?query=A%20simple%20minimalist%20abstract%20avatar%20with%20warm%20amber%20background%2C%20soft%20geometric%20shape%2C%20clean%20design%2C%20modern%20style&width=80&height=80&seq=avatar-02&orientation=squarish",
    name: "深夜瓜田守望者",
    time: "1小时前",
    content: "我就想问，这种级别的爆料以后能不能多来点？每天就等着更新呢，比追剧还有意思！",
    likes: 1.8,
    tag: "热评"
  },
  {
    id: 3,
    avatar: "https://readdy.ai/api/search-image?query=A%20simple%20minimalist%20abstract%20avatar%20with%20warm%20rose%20background%2C%20soft%20geometric%20shape%2C%20clean%20design%2C%20modern%20style&width=80&height=80&seq=avatar-03&orientation=squarish",
    name: "理性吃瓜群众",
    time: "2小时前",
    content: "这篇汇总做得很全面，把各个角度的信息都整理出来了，不用到处翻着看了，收藏了！",
    likes: 1.5,
    tag: "精选"
  },
  {
    id: 4,
    avatar: "https://readdy.ai/api/search-image?query=A%20simple%20minimalist%20abstract%20avatar%20with%20warm%20orange%20background%2C%20soft%20geometric%20shape%2C%20clean%20design%2C%20modern%20style&width=80&height=80&seq=avatar-04&orientation=squarish",
    name: "今天也在吃瓜",
    time: "3小时前",
    content: "每日大赛那个板块能不能固定更新啊？我每天都要刷好几遍，生怕错过什么新瓜。",
    likes: 1.2,
    tag: "精选"
  },
  {
    id: 5,
    avatar: "https://readdy.ai/api/search-image?query=A%20simple%20minimalist%20abstract%20avatar%20with%20warm%20gold%20background%2C%20soft%20geometric%20shape%2C%20clean%20design%2C%20modern%20style&width=80&height=80&seq=avatar-05&orientation=squarish",
    name: "瓜田里的守望者",
    time: "5小时前",
    content: "吃瓜归吃瓜，但还是要注意辨别真假信息。感谢平台整理了这么多靠谱来源的内容。",
    likes: 0.9,
    tag: ""
  }
];

export const topicsData = [
  { id: 1, name: "顶流回应争议", heat: "爆", count: "1,256万" },
  { id: 2, name: "热播剧大结局", heat: "热", count: "987万" },
  { id: 3, name: "综艺录制现场", heat: "热", count: "654万" },
  { id: 4, name: "音乐节阵容", heat: "新", count: "432万" },
  { id: 5, name: "电竞选手退役", heat: "热", count: "389万" },
  { id: 6, name: "电影定档官宣", heat: "新", count: "321万" },
  { id: 7, name: "明星穿搭翻车", heat: "", count: "267万" },
  { id: 8, name: "综艺CP上分", heat: "", count: "198万" },
  { id: 9, name: "新歌首发预告", heat: "新", count: "154万" },
  { id: 10, name: "网红翻车现场", heat: "热", count: "143万" }
];

export const aboutData = {
  title: "关于今日吃瓜",
  content: "今日吃瓜是一个专注于娱乐资讯与热点话题聚合的内容平台。我们致力于为吃瓜爱好者提供最新、最全、最有趣的每日大赛与话题合集，涵盖娱乐圈、影视综艺、音乐、电竞、社会热点等多个领域。平台每日更新，通过智能聚合与人工精选相结合的方式，确保每一条内容都值得细品。无论是明星八卦、热门综艺讨论，还是网络热议话题，今日吃瓜都能让你一站式获取，轻松跟上每一天的热点节奏。",
  stats: [
    { label: "每日更新", value: "50+", icon: "ri-refresh-line" },
    { label: "话题覆盖", value: "9大", icon: "ri-stack-line" },
    { label: "活跃读者", value: "百万级", icon: "ri-user-smile-line" },
    { label: "内容板块", value: "13个", icon: "ri-layout-grid-line" }
  ]
};

export const featuresData = [
  {
    id: 1,
    icon: "ri-flashlight-line",
    title: "极速更新",
    desc: "全天候追踪全网热点，第一时间推送最新吃瓜资讯，不错过任何一个精彩瞬间。"
  },
  {
    id: 2,
    icon: "ri-file-list-3-line",
    title: "全面汇总",
    desc: "多角度、多渠道信息聚合，为你呈现事件全貌，告别碎片化阅读。"
  },
  {
    id: 3,
    icon: "ri-user-heart-line",
    title: "社区互动",
    desc: "百万吃瓜爱好者聚集地，热门评论、观点碰撞，一起吃瓜更有趣。"
  },
  {
    id: 4,
    icon: "ri-shield-check-line",
    title: "内容甄选",
    desc: "人工精选+智能过滤，剔除低质虚假信息，确保每一条瓜都值得品味。"
  }
];

export const mediaData = [
  {
    id: 1,
    title: "本周吃瓜大盘点：五大热门事件回顾",
    duration: "15:32",
    cover: "https://readdy.ai/api/search-image?query=A%20modern%20video%20player%20interface%20with%20warm%20orange%20gradient%20overlay%2C%20abstract%20entertainment%20news%20theme%2C%20cinematic%20atmosphere%2C%20clean%20minimal%20design%2C%20professional%20broadcast%20style&width=640&height=360&seq=media-01&orientation=landscape",
    views: "23.4万",
    tag: "周刊"
  },
  {
    id: 2,
    title: "深度解读：热门综艺背后的制作故事",
    duration: "22:08",
    cover: "https://readdy.ai/api/search-image?query=A%20behind%20the%20scenes%20TV%20production%20atmosphere%20with%20warm%20amber%20lighting%2C%20abstract%20artistic%20style%2C%20cinematic%20composition%2C%20soft%20textures%2C%20documentary%20film%20vibe&width=640&height=360&seq=media-02&orientation=landscape",
    views: "18.9万",
    tag: "深度"
  },
  {
    id: 3,
    title: "瓜友面对面：本期读者最关心的话题投票",
    duration: "09:45",
    cover: "https://readdy.ai/api/search-image?query=A%20warm%20and%20inviting%20talk%20show%20style%20setting%20with%20soft%20coral%20and%20gold%20tones%2C%20abstract%20conversation%20theme%2C%20cozy%20atmosphere%2C%20editorial%20style%2C%20friendly%20vibe&width=640&height=360&seq=media-03&orientation=landscape",
    views: "12.7万",
    tag: "互动"
  }
];

export const rankingData = [
  { rank: 1, title: "顶流艺人深夜发文，多方回应持续发酵", heat: "1,256万", trend: "up" },
  { rank: 2, title: "热播剧大结局争议，编剧导演各执一词", heat: "987万", trend: "up" },
  { rank: 3, title: "知名综艺录制意外，节目组发布正式声明", heat: "654万", trend: "up" },
  { rank: 4, title: "年度音乐节阵容全公布，票务系统崩溃", heat: "432万", trend: "new" },
  { rank: 5, title: "顶配电竞选手退役，八年职业生涯回顾", heat: "389万", trend: "up" },
  { rank: 6, title: "年末大片定档，主演阵容引发期待", heat: "321万", trend: "new" },
  { rank: 7, title: "明星红毯造型PK，时尚博主逐一点评", heat: "267万", trend: "up" }
];

export const updatesData = [
  { id: 1, time: "10分钟前", content: "【更新】顶流艺人工作室发布律师声明，将对不实传闻采取法律手段", icon: "ri-alert-line", type: "重要" },
  { id: 2, time: "28分钟前", content: "【快讯】综艺节目制作方召开媒体沟通会，详细说明事件经过", icon: "ri-megaphone-line", type: "快讯" },
  { id: 3, time: "1小时前", content: "【热议】热播剧编剧在粉丝群回应争议，称结局有多重解读空间", icon: "ri-chat-3-line", type: "热议" },
  { id: 4, time: "2小时前", content: "【爆料】知情人士透露某对明星情侣已低调分手", icon: "ri-eye-line", type: "爆料" },
  { id: 5, time: "3小时前", content: "【官宣】音乐节第三批阵容公布，新增两位国际艺人", icon: "ri-music-line", type: "官宣" },
  { id: 6, time: "5小时前", content: "【回顾】电竞选手职业生涯高光时刻全记录视频发布", icon: "ri-play-circle-line", type: "回顾" },
  { id: 7, time: "7小时前", content: "【话题】网友票选年度最佳综艺名场面Top10出炉", icon: "ri-trophy-line", type: "话题" },
  { id: 8, time: "9小时前", content: "【数据】本周吃瓜热度排行榜：娱乐圈话题占比超六成", icon: "ri-bar-chart-line", type: "数据" },
  { id: 9, time: "12小时前", content: "【预告】明日将上线「年度吃瓜报告」专题，敬请期待", icon: "ri-calendar-check-line", type: "预告" }
];

export const contactData = {
  title: "投稿爆料",
  subtitle: "你有独家消息？欢迎联系我们",
  description: "今日吃瓜始终开放读者投稿与爆料通道。如果你掌握第一手资讯或独家线索，欢迎通过以下方式与我们取得联系。我们承诺对爆料人信息严格保密，并对采用的内容给予署名或奖励。",
  email: "tips@jirichigua.com",
  wechat: "jirichigua",
  tips: ["信息真实可靠，请勿捏造", "提供可核实的证据或线索", "爆料人信息将严格保密", "优质内容将获得平台推荐"]
};

export const cardsData = [
  {
    id: 1,
    tag: "深度",
    title: "从顶流争议看娱乐圈公关策略的变迁",
    summary: "当社交媒体成为舆论主战场，明星团队面对危机时的应对方式也在发生深刻变化。本文梳理了近三年来娱乐圈重大公关案例的演变趋势。",
    image: "https://readdy.ai/api/search-image?query=A%20dramatic%20theater%20backstage%20with%20warm%20coral%20and%20gold%20lighting%2C%20abstract%20artistic%20style%2C%20mysterious%20atmosphere%2C%20editorial%20photography%2C%20soft%20shadows%2C%20cinematic%20composition&width=600&height=400&seq=card-01&orientation=landscape",
    author: "深度观察员",
    time: "2小时前",
    reads: "8.9万"
  },
  {
    id: 2,
    tag: "盘点",
    title: "本年度最令人意外的十大娱乐圈反转事件",
    summary: "有些瓜吃着吃着就反转了，有些反转转着转着又回去了。回顾这一年，哪些事件让你大跌眼镜、始料未及？",
    image: "https://readdy.ai/api/search-image?query=A%20dramatic%20twist%20and%20turn%20concept%20with%20warm%20amber%20and%20coral%20abstract%20shapes%2C%20artistic%20style%2C%20dynamic%20composition%2C%20surprising%20reveal%20atmosphere%2C%20editorial%20design&width=600&height=400&seq=card-02&orientation=landscape",
    author: "瓜田总结师",
    time: "5小时前",
    reads: "12.3万"
  },
  {
    id: 3,
    tag: "解读",
    title: "综艺节目为何越来越依赖「剧本」争议？",
    summary: "从近年来的综艺争议事件出发，探讨真人秀节目在「真实」与「娱乐效果」之间的平衡难题。",
    image: "https://readdy.ai/api/search-image?query=A%20TV%20production%20meeting%20room%20with%20scripts%20and%20storyboards%2C%20warm%20rose%20and%20gold%20tones%2C%20abstract%20artistic%20style%2C%20creative%20atmosphere%2C%20documentary%20film%20vibe&width=600&height=400&seq=card-03&orientation=landscape",
    author: "综艺观察家",
    time: "8小时前",
    reads: "6.7万"
  },
  {
    id: 4,
    tag: "分析",
    title: "电竞选手退役潮背后：黄金一代的告别",
    summary: "当一批又一批陪伴我们青春的电竞选手宣布退役，这不仅是个人的告别，更标志着一个时代的落幕。",
    image: "https://readdy.ai/api/search-image?query=A%20dramatic%20farewell%20scene%20in%20a%20futuristic%20esports%20arena%20with%20warm%20golden%20spotlight%2C%20abstract%20artistic%20style%2C%20emotional%20atmosphere%2C%20cinematic%20composition%2C%20touching%20moment&width=600&height=400&seq=card-04&orientation=landscape",
    author: "电竞老炮",
    time: "1天前",
    reads: "15.6万"
  },
  {
    id: 5,
    tag: "预测",
    title: "下半年最值得期待的影视剧大盘点",
    summary: "暑期档过后，还有哪些值得关注的影视作品即将与观众见面？我们整理了最受期待的片单。",
    image: "https://readdy.ai/api/search-image?query=A%20cinema%20marquee%20with%20upcoming%20movie%20posters%2C%20warm%20coral%20and%20amber%20lighting%2C%20abstract%20artistic%20style%2C%20exciting%20anticipation%20atmosphere%2C%20editorial%20photography&width=600&height=400&seq=card-05&orientation=landscape",
    author: "影视频道",
    time: "2天前",
    reads: "9.4万"
  }
];

export const faqData = [
  {
    id: 1,
    question: "今日吃瓜的内容多久更新一次？",
    answer: "我们保持每日更新节奏，全天候追踪全网热点。重大事件发生后，相关内容通常在30分钟内即可上线。您可以在「最新动态」板块查看实时更新记录，确保不错过任何精彩内容。"
  },
  {
    id: 2,
    question: "如何确保吃瓜内容的真实性和可靠性？",
    answer: "今日吃瓜坚持「人工精选+多方交叉验证」的内容审核机制。我们的编辑团队会对每一条热点信息进行来源核实与多方比对，并标注信息来源。对于未经证实的内容，会明确标注「传闻」或「待核实」标签。"
  },
  {
    id: 3,
    question: "我可以向平台投稿或提供线索吗？",
    answer: "当然可以！我们非常欢迎读者提供独家线索和优质内容。您可以通过「投稿爆料」板块中的联系方式与我们取得联系，编辑团队会在24小时内回复。优质投稿一经采用，将获得署名推荐和相应奖励。"
  },
  {
    id: 4,
    question: "今日吃瓜有手机App吗？",
    answer: "目前今日吃瓜以网页版为主要访问方式，完美适配手机浏览器访问。您可以将网站添加到手机主屏幕，获得接近原生App的使用体验。独立的移动端App正在开发中，敬请期待后续公告。"
  }
];

export const appData = {
  title: "随时随地，轻松吃瓜",
  subtitle: "将今日吃瓜添加到手机主屏幕，第一时间获取最新瓜料",
  steps: [
    { step: 1, icon: "ri-safari-line", text: "使用手机浏览器打开本站" },
    { step: 2, icon: "ri-share-forward-line", text: "点击浏览器底部「分享」按钮" },
    { step: 3, icon: "ri-add-box-line", text: "选择「添加到主屏幕」" }
  ]
};